import React from 'react';
import colorVariants from "@/json/color_variants.json"
// import Button_1 from '../Atoms/Buttons/Button_1';
// import Link from 'next/link';

const SpecializationChildCard = ({ colors, show, textCaption, border, textURL, textBody, button1, button2, iconPath }) => {

  const backgroundColorVariants = {
    gray: 'bg-gray-100 dark:bg-gray-600',
    white: 'bg-white dark:bg-gray-900',
    blue: 'bg-blue-600 dark:bg-blue-500',
    indigo: 'bg-indigo-600 dark:bg-indigo-500',
    violet: 'bg-violet-600 dark:bg-violet-600',
    purple: 'bg-purple-600 dark:bg-purple-500',
    fuchsia: 'bg-fuchsia-600 dark:bg-fuchsia-600',
    pink: 'bg-pink-600 dark:bg-pink-600',

  }

  const borderColorVariants = {
     amber: 'border-amber-500',
     green: 'border-green-500',
     gray: 'border-gray-500 dark:border-gray-500',
    white: 'bg-white dark:bg-gray-900',
    blue: 'border-blue-400 dark:border-blue-400',
    indigo: 'border-indigo-400 dark:border-indigo-400',
     violet: 'border-violet-400 dark:border-violet-400',
     purple: 'border-purple-400 dark:border-purple-400',
     fuchsia: 'border-fuchsia-400 dark:border-fuchsia-400',
     pink: 'border-pink-400 dark:border-pink-400',
  }

  const textColorVariants = { 
    gray: 'text-gray-500 dark:text-gray-500',
    white: 'text-white',
    blue: 'text-blue-600',
    indigo: 'text-indigo-600',
     violet: 'text-violet-600',
     purple: 'text-purple-600',
     fuchsia: 'text-fuchsia-600',
     pink: 'text-pink-600',
  }

  
  return (
<div className={`bg-white dark:bg-slate-900 rounded-3xl flex flex-col flex-grow h-full max-w-36 px-4 min-w-36 max-h-36 min-h-36 ease-in-out transition-transform transform duration-500 ${show ? 'visible' : 'hidden'} text-center  ${colors.background ? `${backgroundColorVariants[colors.background]}` : 'bg-inherit'} ${colors.border ? `border-2 ${colorVariants.borderColors[colors.border]}` : 'border-4 border-black dark:border-gray-400'}`}>
  {iconPath && (
    <div className={`rounded-full border-2 dark:border-gray-400 p-0.5 h-20 w-20 flex items-center justify-center mx-auto`}>
      <img src={iconPath} className="svg-icons-1 h-20 w-20" alt=""/>
    </div>
  )}
  
  <div className="relative flex-1 flex flex-col items-center justify-center">

    <div className={`flex items-center justify-center font-montserrat font-semibold ${textColorVariants[colors.caption] || 'text-white'} text-base`}>
      {textCaption && <>{textCaption}</>}
    </div>

  </div>

  {textURL && (
    <div className='text-center text-black dark:text-gray-400'>
      <a target="_blank" className='hover:text-gray-500 duration-300' href={"https://"+textURL}>
        {textURL}
      </a>
    </div>
  )}
  
  {/* <div className={`pt-12 px-8 overflow-y-auto h-full text-black dark:text-gray-300 text-base font-inter`}>
    {textBody}
  </div> */}
</div>
  );
}

export default SpecializationChildCard;




// import React from 'react';
// import Button_1 from '../Atoms/Buttons/Button_1';

// const ContentBox = ({colors, textCaption, textBody, button1, button2}) => {
//   return (
//     <div className={`rounded-3xl flex flex-col items-center justify-center py-32 h-full bg-${colors.background.tWind}`} style={{backgroundColor: colors.background.hex}}>
//       <h2 className={`text-${colors.text.title} text-4xl fixed top-24 w-full text-center`}>
//         <strong style={{fontFamily: 'Roboto', fontWeight:'300'}}>
//         {/* Pink: "#e91e63 */}

//           {textCaption}

//         </strong>
//       </h2>
//       <br />
// <div className='self-start px-8'>
//   {/* {textBody.split('<br/>').map(text=>{return <>{text}<br/></>})} */}
//   {textBody}
// </div>
//      {/* {button1}
//       <br />
//       {button2}
//       <br /> */}
//     </div>
//   );
// }

// export default ContentBox;
